/**
 * English-only input guard.
 *
 * The humanizer (the released HIP LoRA adapter) is trained and validated on
 * ENGLISH ONLY. Non-English input doesn't just degrade — the English-shaped
 * adapter "translates" it (Chinese in → English out), which is confusing and
 * useless. Editors use this result only to detect unsupported characters;
 * they preserve the original input and ask the user to edit it.
 *
 * Strategy is a BLACKLIST, not a whitelist, so legitimate English typography
 * survives: accented Latin (café, résumé, naïve), em/en dashes (— –), curly
 * quotes (“ ” ‘ ’), and ellipsis (…) all pass through untouched. We remove:
 *   - CJK / Japanese / Korean scripts and their punctuation & full-width forms
 *   - control characters (keeping the only two that belong in text: \t and \n)
 */
const DISALLOWED = new RegExp(
  "[" +
    "\\u2E80-\\u2EFF" + // CJK radicals supplement
    "\\u3000-\\u303F" + // CJK symbols & punctuation （、。「」… etc.)
    "\\u3040-\\u30FF" + // Hiragana + Katakana
    "\\u31C0-\\u31EF" + // CJK strokes
    "\\u3400-\\u4DBF" + // CJK Unified Ideographs Extension A
    "\\u4E00-\\u9FFF" + // CJK Unified Ideographs (Chinese)
    "\\uA000-\\uA4CF" + // Yi
    "\\uAC00-\\uD7AF" + // Hangul syllables
    "\\uF900-\\uFAFF" + // CJK compatibility ideographs
    "\\uFF00-\\uFFEF" + // full-width / half-width forms
    "]" +
    // control chars, but keep TAB (U+0009) and LF (U+000A)
    "|[\\u0000-\\u0008\\u000B\\u000C\\u000E-\\u001F\\u007F]",
  "g",
);

export interface FilteredInput {
  /** The cleaned, English-only text. */
  text: string;
  /** How many characters were removed (0 = input was already clean). */
  removed: number;
}

/** Strip non-English / illegal characters from `input`. */
export function filterEnglishOnly(input: string): FilteredInput {
  const text = input.replace(DISALLOWED, "");
  return { text, removed: input.length - text.length };
}
